import { createMarkdownItParser } from "./use-markdown-it";

/** `fact` parser with block constructs disabled, so output is safe inside a single `<Text>`. */
export const inlineMarkdownIt = createMarkdownItParser("fact").disable([
	"list",
	"table",
	"code",
	"lheading",
]);

/** Plain text with markdown markers removed, for accessibility labels. */
export const stripInlineMarkdown = (text: string): string =>
	(inlineMarkdownIt.parseInline(text, {})[0]?.children ?? [])
		.map((token) =>
			token.type === "softbreak" || token.type === "hardbreak"
				? "\n"
				: token.content,
		)
		.join("");
